import ColorPicker from "../picker/ColorPicker";

const AVAILABLE_PLATFORMS = [
    { value: 'google', label: 'Google', icon: '🔍' },
    { value: 'tripadvisor', label: 'TripAdvisor', icon: '🦉' },
    { value: 'facebook', label: 'Facebook', icon: '👍' },
    { value: 'yelp', label: 'Yelp', icon: '⭐' },
    { value: 'ubereats', label: 'Uber Eats', icon: '🍔' },
    { value: 'deliveroo', label: 'Deliveroo', icon: '🚴' },
    { value: 'thefork', label: 'TheFork', icon: '🍴' },
];

export default function ReviewCellProperties({ cell, onChange }) {
    // S'assurer que platforms est toujours un tableau
    const platforms = Array.isArray(cell.platforms) ? cell.platforms : [];

    const addPlatform = () => {
        const newPlatforms = [...platforms, { platform: 'google', url: '', display_mode: 'qrcode' }];
        onChange(cell.cell_id, { platforms: newPlatforms, type: cell.type });
    };

    const removePlatform = (index) => {
        const newPlatforms = platforms.filter((_, i) => i !== index);
        onChange(cell.cell_id, { platforms: newPlatforms, type: cell.type });
    };

    const updatePlatform = (index, field, value) => {
        const newPlatforms = [...platforms];
        newPlatforms[index] = { ...newPlatforms[index], [field]: value };
        onChange(cell.cell_id, { platforms: newPlatforms, type: cell.type });
    };

    return (
        <div className="property-section">
            <div className="property-section-title">Avis & Notation</div>
            
            {/* Textes */}
            <div className="property-row">
                <div className="property-label">Titre</div>
                <input 
                    className="property-input property-input-small" 
                    type="text" 
                    placeholder="Votre avis compte !"
                    value={cell.title || ''} 
                    onChange={(e) => onChange(cell.cell_id, { title: e.target.value, type: cell.type })}
                />
            </div>
            <div className="property-row">
                <div className="property-label">Sous-titre</div>
                <input 
                    className="property-input property-input-small" 
                    type="text" 
                    placeholder="Aidez-nous à nous améliorer..."
                    value={cell.subtitle || ''} 
                    onChange={(e) => onChange(cell.cell_id, { subtitle: e.target.value, type: cell.type })}
                />
            </div>
            <div className="property-row">
                <div className="property-label">Message de remerciement</div>
                <input 
                    className="property-input property-input-small" 
                    type="text" 
                    placeholder="Merci pour votre soutien ! 💖"
                    value={cell.thank_you_message || ''} 
                    onChange={(e) => onChange(cell.cell_id, { thank_you_message: e.target.value, type: cell.type })}
                />
            </div>
            <div className="property-row">
                <div className="property-label">Afficher le remerciement</div>
                <input 
                    className="property-input property-input-small" 
                    type="checkbox" 
                    checked={cell.styles_properties?.show_thank_you !== false} 
                    onChange={(e) => onChange(cell.cell_id, { styles_properties: { ...cell.styles_properties, show_thank_you: e.target.checked }, type: cell.type })}
                />
            </div>

            {/* Layout */}
            <div className="property-section-title">Disposition</div>
            <div className="property-row">
                <div className="property-label">Template</div>
                <select 
                    className="property-input property-input-small" 
                    value={cell.template_name || 'default'} 
                    onChange={(e) => onChange(cell.cell_id, { template_name: e.target.value, type: cell.type })}
                >
                    <option value="default">Par défaut</option>
                    <option value="modern">Moderne</option>
                    <option value="elegant">Élégant</option>
                    <option value="playful">Ludique</option>
                </select>
            </div>
            <div className="property-row">
                <div className="property-label">Layout</div>
                <select 
                    className="property-input property-input-small" 
                    value={cell.layout || 'grid'} 
                    onChange={(e) => onChange(cell.cell_id, { layout: e.target.value, type: cell.type })}
                >
                    <option value="grid">Grille</option>
                    <option value="horizontal">Horizontal</option>
                    <option value="vertical">Vertical</option>
                </select>
            </div>
            <div className="property-row">
                <div className="property-label">Style des cartes</div>
                <select 
                    className="property-input property-input-small" 
                    value={cell.styles_properties?.card_style || 'default'} 
                    onChange={(e) => onChange(cell.cell_id, { styles_properties: { ...cell.styles_properties, card_style: e.target.value }, type: cell.type })}
                >
                    <option value="default">Par défaut</option>
                    <option value="minimal">Minimal</option>
                    <option value="gradient">Dégradé</option>
                </select>
            </div>

            {/* Plateformes */}
            <div className="property-section-title">
                Plateformes
                <button 
                    onClick={addPlatform}
                    style={{
                        marginLeft: '10px',
                        padding: '2px 8px',
                        fontSize: '12px',
                        background: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                    }}
                >
                    + Ajouter
                </button>
            </div>
            
            {platforms.map((p, index) => (
                <div key={index} style={{ 
                    background: '#f5f5f5', 
                    padding: '10px', 
                    borderRadius: '8px', 
                    marginBottom: '10px' 
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
                            {AVAILABLE_PLATFORMS.find(pl => pl.value === p.platform)?.icon} Plateforme {index + 1}
                        </span>
                        <button 
                            onClick={() => removePlatform(index)}
                            style={{
                                padding: '2px 6px',
                                fontSize: '10px',
                                background: '#f44336',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            }}
                        >
                            ✕
                        </button>
                    </div>
                    <div className="property-row">
                        <div className="property-label">Type</div>
                        <select 
                            className="property-input property-input-small" 
                            value={p.platform} 
                            onChange={(e) => updatePlatform(index, 'platform', e.target.value)}
                        >
                            {AVAILABLE_PLATFORMS.map(pl => (
                                <option key={pl.value} value={pl.value}>
                                    {pl.icon} {pl.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="property-row">
                        <div className="property-label">URL</div>
                        <input 
                            className="property-input property-input-small" 
                            type="text" 
                            placeholder="https://..."
                            value={p.url || ''} 
                            onChange={(e) => updatePlatform(index, 'url', e.target.value)}
                        />
                    </div>
                    <div className="property-row">
                        <div className="property-label">Mode d'affichage</div>
                        <select 
                            className="property-input property-input-small" 
                            value={p.display_mode || 'qrcode'} 
                            onChange={(e) => updatePlatform(index, 'display_mode', e.target.value)}
                        >
                            <option value="qrcode">📱 QR Code</option>
                            <option value="link">🔗 Lien cliquable</option>
                        </select>
                    </div>
                </div>
            ))}

            {platforms.length === 0 && (
                <div style={{ 
                    textAlign: 'center', 
                    padding: '20px', 
                    color: '#999',
                    fontSize: '12px' 
                }}>
                    Aucune plateforme configurée.<br/>
                    Cliquez sur "+ Ajouter" pour commencer.
                </div>
            )}

            {/* Couleurs */}
            <div className="property-section-title">Couleurs</div>
            <div className="property-row">
                <div className="property-label">Couleur principale</div>
                <ColorPicker 
                    value={cell.styles_properties?.primary_color || '#FF6B6B'} 
                    onChange={(color) => onChange(cell.cell_id, { styles_properties: { ...cell.styles_properties, primary_color: color }, type: cell.type })}
                />
            </div>
            <div className="property-row">
                <div className="property-label">Couleur secondaire</div>
                <ColorPicker 
                    value={cell.styles_properties?.secondary_color || '#4ECDC4'} 
                    onChange={(color) => onChange(cell.cell_id, { styles_properties: { ...cell.styles_properties, secondary_color: color }, type: cell.type })}
                />
            </div>
            <div className="property-row">
                <div className="property-label">Couleur d'accent</div>
                <ColorPicker 
                    value={cell.styles_properties?.accent_color || '#FFE66D'} 
                    onChange={(color) => onChange(cell.cell_id, { styles_properties: { ...cell.styles_properties, accent_color: color }, type: cell.type })}
                />
            </div>
            <div className="property-row">
                <div className="property-label">Couleur de fond</div>
                <ColorPicker 
                    value={cell.styles_properties?.background_color || '#FAFAFA'} 
                    onChange={(color) => onChange(cell.cell_id, { styles_properties: { ...cell.styles_properties, background_color: color }, type: cell.type })}
                />
            </div>
            <div className="property-row">
                <div className="property-label">Couleur du texte</div>
                <ColorPicker 
                    value={cell.styles_properties?.text_color || '#333333'} 
                    onChange={(color) => onChange(cell.cell_id, { styles_properties: { ...cell.styles_properties, text_color: color }, type: cell.type })}
                />
            </div>

            {/* Typographie */}
            <div className="property-section-title">Typographie</div>
            <div className="property-row">
                <div className="property-label">Police de caractères</div>
                <input 
                    className="property-input property-input-small" 
                    type="text" 
                    placeholder="Poppins, sans-serif"
                    value={cell.styles_properties?.font_family || ''} 
                    onChange={(e) => onChange(cell.cell_id, { styles_properties: { ...cell.styles_properties, font_family: e.target.value }, type: cell.type })}
                />
            </div>
        </div>
    );
}

